<form nz-form [formGroup]="formGroup" (ngSubmit)="submit();">
  <div class="page-content-section">
    <fieldset>
      <legend>
        {{'Information' | translate }}
      </legend>
      <nz-form-item *ngIf="mode === 'edit'">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Code">
          {{'Id' | translate }}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the id.' | translate ">
          <input nz-input formControlName="Id" id="Id" readonly />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Name">
          {{'Name' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the name.' | translate ">
          <input nz-input formControlName="Name" id="Name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" [nzNoColon]="true" nzFor="Description">
          {{'Description' | translate }}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <input nz-input formControlName="Description" id="Description" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="IsUnique">
          {{'Related Entity Type' | translate }}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please select the realted entity type' | translate ">
          <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'Please select the realted entity type' | translate " formControlName="RelatedObjectType"
            id="RelatedObjectType">
            <ng-container *ngFor="let option of entitiesValues">
              <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
              </nz-option>
            </ng-container>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </fieldset>
  </div>
  <input type="submit" style="display: none" />
</form>
